import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import {
  App,
  getAnzahlVorschaeden,
  ThhPferdVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { TaasTarifrisikoschluesselTHH } from '@ps20/bff-models';
import { ThhPferdActions } from '../thhPferdActions';

export interface Vorschaeden {
  vorhanden: boolean | null;
  thhPferdVorschaeden: number;
}

export const vorschaedenReducer = function (
  sectionState: Vorschaeden = null,
  action: AnyAction,
): Vorschaeden {
  switch (action.type) {
    case ThhPferdActions.VORSCHAEDEN_VORHANDEN: {
      return {
        ...sectionState,
        thhPferdVorschaeden: 0,
        vorhanden: action.payload,
      };
    }
    case ThhPferdActions.VORSCHADEN_VALUE_CHANGED: {
      const { vorschadenId, value } = action.payload;
      return { ...sectionState, [vorschadenId]: value };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: ThhPferdVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.THH_PFERD) {
        const anzVorschaedenPferd = getAnzahlVorschaeden(
          actionPayload.vorvertragBausteinList,
          TaasTarifrisikoschluesselTHH.P,
        );
        return {
          ...sectionState,
          vorhanden: anzVorschaedenPferd > 0,
          thhPferdVorschaeden: anzVorschaedenPferd,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
